export { inputsCustomizations } from './inputs';
export { dataDisplayCustomizations } from './dataDisplay';
export { feedbackCustomizations } from './feedback';
export { navigationCustomizations } from './navigation';
export { surfacesCustomizations } from './surfaces';
export { iconCustomizations } from './icon';

import { inputsCustomizations } from './inputs';
import { dataDisplayCustomizations } from './dataDisplay';
import { feedbackCustomizations } from './feedback';
import { navigationCustomizations } from './navigation';
import { surfacesCustomizations } from './surfaces';
import { iconCustomizations } from './icon';


export const buildCustomizations = (theme) => {
  const toObj = (c) => (typeof c === 'function' ? c(theme) : c || {});
  return {
    ...toObj(inputsCustomizations),
    ...toObj(dataDisplayCustomizations),
    ...toObj(feedbackCustomizations),
    ...toObj(navigationCustomizations),
    ...toObj(surfacesCustomizations),
    ...toObj(iconCustomizations),
  };
};